import React from 'react';
import { Outlet } from 'react-router-dom';
import DealRoomProvider from './providers/DealRoom';

const DealRoomEditRouter: React.FC = () => (
  <DealRoomProvider>
    <Outlet />
  </DealRoomProvider>
);

export default DealRoomEditRouter;
